import {useMemo} from 'react';
import parse from 'html-react-parser';

const useParseSeomatic = seomatic =>
  useMemo(() => {
    const {metaJsonLdContainer = '', metaTitleContainer = '', metaTagContainer = '', metaLinkContainer = '', metaScriptContainer = ''} = seomatic ?? {};

    const splitJsonLdStringIntoArray = metaJsonLdContainer.replace(/\<\/script\>/g, '').split(`<script type="application/ld+json">`);

    let parsedMetaScriptContainer = {};
    try {
      parsedMetaScriptContainer = JSON.parse(metaScriptContainer || '{}');
    } catch (e) {
      console.error('Failed parsing seomatic scripts:', e, metaScriptContainer);
      parsedMetaScriptContainer = {};
    }

    // Safely parse HTML, catching any errors
    const safeParse = (html) => {
      if (!html || html.trim() === '') return null;
      try {
        return parse(html);
      } catch (e) {
        console.error('Failed parsing HTML:', e, html);
        return null;
      }
    };

    return {
      metaJsonLdArray: splitJsonLdStringIntoArray,
      metaTitle: safeParse(metaTitleContainer),
      metaTag: safeParse(metaTagContainer),
      metaLink: safeParse(metaLinkContainer),
      metaScriptHead: safeParse(parsedMetaScriptContainer?.script ?? ''),
      metaScriptBody: safeParse(parsedMetaScriptContainer?.bodyScript ?? ''),
    };
  }, [seomatic]);

export default useParseSeomatic;
